export const ENDPOINTS_CONNECTORS_PANEL_GET_LIST_INIT = 'ENDPOINTS_CONNECTORS_PANEL_GET_LIST_INIT';
export const ENDPOINTS_CONNECTORS_PANEL_GET_LIST_SUCCESS = 'ENDPOINTS_CONNECTORS_PANEL_GET_LIST_SUCCESS';
export const ENDPOINTS_CONNECTORS_PANEL_GET_LIST_FAILURE = 'ENDPOINTS_CONNECTORS_PANEL_GET_LIST_FAILURE';

export const ENDPOINTS_CONNECTORS_PANEL_GET_PERIODS_LIST_INIT = 'ENDPOINTS_CONNECTORS_PANEL_GET_PERIODS_LIST_INIT';
export const ENDPOINTS_CONNECTORS_PANEL_GET_PERIODS_LIST_SUCCESS = 'ENDPOINTS_CONNECTORS_PANEL_GET_PERIODS_LIST_SUCCESS';
export const ENDPOINTS_CONNECTORS_PANEL_GET_PERIODS_LIST_FAILURE = 'ENDPOINTS_CONNECTORS_PANEL_GET_PERIODS_LIST_FAILURE';

export const ENDPOINTS_CONNECTORS_PANEL_RUN_CONNECTOR_INIT = 'ENDPOINTS_CONNECTORS_PANEL_RUN_CONNECTOR_INIT';
export const ENDPOINTS_CONNECTORS_PANEL_RUN_CONNECTOR_SUCCESS = 'ENDPOINTS_CONNECTORS_PANEL_RUN_CONNECTOR_SUCCESS';
export const ENDPOINTS_CONNECTORS_PANEL_RUN_CONNECTOR_FAILURE = 'ENDPOINTS_CONNECTORS_PANEL_RUN_CONNECTOR_FAILURE';

export const ENDPOINTS_CONNECTORS_PANEL_GET_LAST_UPDATES_LIST_INIT = 'ENDPOINTS_CONNECTORS_PANEL_GET_LAST_UPDATES_LIST_INIT';
export const ENDPOINTS_CONNECTORS_PANEL_GET_LAST_UPDATES_LIST_SUCCESS = 'ENDPOINTS_CONNECTORS_PANEL_GET_LAST_UPDATES_LIST_SUCCESS';
export const ENDPOINTS_CONNECTORS_PANEL_GET_LAST_UPDATES_LIST_FAILURE = 'ENDPOINTS_CONNECTORS_PANEL_GET_LAST_UPDATES_LIST_FAILURE';

export const ENDPOINTS_CONNECTORS_PANEL_GET_CALCULATION_UNITS_INIT = 'ENDPOINTS_CONNECTORS_PANEL_GET_CALCULATION_UNITS_INIT';
export const ENDPOINTS_CONNECTORS_PANEL_GET_CALCULATION_UNITS_SUCCESS = 'ENDPOINTS_CONNECTORS_PANEL_GET_CALCULATION_UNITS_SUCCESS';
export const ENDPOINTS_CONNECTORS_PANEL_GET_CALCULATION_UNITS_FAILURE = 'ENDPOINTS_CONNECTORS_PANEL_GET_CALCULATION_UNITS_FAILURE';

export const ENDPOINTS_CONNECTORS_PANEL_GET_GROUPS_INIT = 'ENDPOINTS_CONNECTORS_PANEL_GET_GROUPS_INIT';
export const ENDPOINTS_CONNECTORS_PANEL_GET_GROUPS_SUCCESS = 'ENDPOINTS_CONNECTORS_PANEL_GET_GROUPS_SUCCESS';
export const ENDPOINTS_CONNECTORS_PANEL_GET_GROUPS_FAILURE = 'ENDPOINTS_CONNECTORS_PANEL_GET_GROUPS_FAILURE';

export const ENDPOINTS_CONNECTORS_PANEL_GET_POLYNOMIALS_LIST_INIT = 'ENDPOINTS_CONNECTORS_PANEL_GET_POLYNOMIALS_LIST_INIT';
export const ENDPOINTS_CONNECTORS_PANEL_GET_POLYNOMIALS_LIST_SUCCESS = 'ENDPOINTS_CONNECTORS_PANEL_GET_POLYNOMIALS_LIST_SUCCESS';
export const ENDPOINTS_CONNECTORS_PANEL_GET_POLYNOMIALS_LIST_FAILURE = 'ENDPOINTS_CONNECTORS_PANEL_GET_POLYNOMIALS_LIST_FAILURE';

export const ENDPOINTS_CONNECTORS_PANEL_RESET = 'ENDPOINTS_CONNECTORS_PANEL_RESET';
export const ENDPOINTS_CONNECTORS_PANEL_SET_PERIOD_ID = 'ENDPOINTS_CONNECTORS_PANEL_SET_PERIOD_ID';




// WEBPACK FOOTER //
// ./source/client/actions/endpointsConnectorsPanel/types.js